module.exports = __webpack_public_path__ + "img/4.ce992b72.jpg";